/**
 * Sales API
 *
 * @author minkyoung.park@emcast.com
 */
 import httpService from "@/api/httpService";

 const checklistApi = {
   
   // 체크리스트 목록 (list)
   // https://dev.clp.kr/api/static/docs/checklist.html#resources-checklist-respondent-fetch-page_request_parameters
   fetchList(params) {
     return httpService.get(`/checklist/respondent`, params);
   },
 
   // 배포된 체크리스트 상세 조회(CheckList Distribution Detail)
   // https://dev.clp.kr/api/static/docs/checklist.html#resources-checklist-respondent-distribution-fetch_request_headers
   checkListDistributionDetails(params) {
     return httpService.get(`/checklist/distribution/${params.postId}`);
   },
    // Edit comment under a post
    submitCheckList(data, checkListId) {
     return httpService.put(`/checklist/respondent/${checkListId}/submit`, data);
   },
   submitCheckListTemp(data, checkListId) {
    return httpService.put(`https://dev.clp.kr/api/checklist/respondent/${checkListId}/temporary`, data);
  },
   submitCheckListDetails(params) {
     return httpService.get(`/checklist/respondent/${params.postId}`);
   },
 
   // 상세(Detail)
   //https://dev.clp.kr/api/static/docs/checklist.html#resources-checklist-respondent-detail-fetch-page_path_parameters
   checkListDetails(id,params) {
     return httpService.get(`/checklist/respondent/detail/${id}`,params);
   },
 
   // delete the checklist being answered and
   //https://dev.clp.kr/api/static/docs/checklist.html#resources-checklist-respondent-delete
   deleteAnswer(id) {
     return httpService.delete(`/checklist/respondent/${id}`);
   },
 
   // Answered by the user or not
   //https://dev.clp.kr/api/static/docs/checklist.html#resources-checklist-respondent-exist
   answeredByUser(id) {
     return httpService.get(`/checklist/respondent/exist/${id}`);
   },
 
   // Reset Question Answer
   //https://dev.clp.kr/api/static/docs/checklist.html#resources-checklist-respondent-reset
   resetQuestionAnswered(id) {
     return httpService.put(`/checklist/respondent/${id}/reset`);
   },
   
   // 체크리스트 진입 및 시작(get Question List)
   // https://dev.clp.kr/api/static/docs/checklist.html#resources-checklist-respondent-enter_request_headers
   getQuestionList(params) {
     return httpService.post(`/checklist/respondent/${params.postId}/enter`);
   },
   // upload image and video
   upload(file) {
     let formData = new FormData();
     formData.append("file", file);
     return httpService.post("/common/attachment", formData)
   },
 
   // list all comment under a post
   // http://54.251.23.221:8080/static/docs/article_comment.html#resources-board-article-fetch
   listComments(postParams, params) {
     //console.log('dasssssssssss',articleId)checklist/respondent/1/comment
     return httpService.get(`/checklist/respondent/${postParams.postId}/comment`, params);
     //return httpService.get(`/board/${postParams.boardId}/article/${postParams.postId}/comment`, params);
   },
 
   boardDetails(params) {
     return httpService.get(`/board/${params.boardId}/article/${params.postId}`);
   },
 
   boardAuth(params){
     return httpService.get(`/checklist/respondent/auth`);
   },
 
   // add comment under a post
   commentPost(params,commentvalue) {
     return httpService.post(`/checklist/respondent/${params.postId}/comment`, commentvalue);
     //return httpService.post(`/board/SNS1/article/${articleId}/comment`, params);
   },
 
    // Edit comment under a post
    commentEdit(params, editCommentValue,id) {
     return httpService.put(`/checklist/respondent/${params.postId}/comment/${id}`, editCommentValue);
   },
 
   // 2Level Reply Comment 
   postReply(params, originId, replyValue) {
     return httpService.post(`/checklist/respondent/${params.postId}/comment/${originId}`, replyValue)
   },
 
    // 2Level Reply Edit Comment
   editReply(params,replyEditId,replyEditValue) {
     return httpService.put(`/checklist/respondent/${params.postId}/comment/${replyEditId}`, replyEditValue)
   },
 
   // 1Level OR 2Level Comment Report 
   reportComment(params, id) {
     return httpService.post(`/board/${params.boardId}/article/${params.postId}/comment/${id}/report`)
   },
 
   // 1Level OR 2Level Comment Delete 
   deleteComment(params, id) {
     return httpService.delete(`/checklist/respondent/${params.postId}/comment/${id}`)
   },
 
   reportPost(params) {
     return httpService.post(`/board/${params.boardId}/article/${params.postId}/report`)
   },
 
   // delete post
   deletePost(params) {
     return httpService.delete(`/board/${params.boardId}/article/${params.postId}`)
   },
 
   // get Category List for post
   fetchCategoryList(params) {
     return httpService.get(`/codes/code/CHECKLIST_TYPE`)
   },
 
   //http://54.251.23.221:8080/static/docs/account.html#resources-account-fetch-info
   fetchMember(params) {
     return httpService.get(`/membership/member`, params);
     // return httpService.get(`/board/SNS1/article/list`,params)
   },
 
   searchTags(str) {
     return httpService.get(`/common/tag/search?name=${str}`);
   },
 
   createTags(str) {
     return httpService.post(`/common/tag`,str);
   },
   
   // Add post
   // https://clpapi.tinkeredu.co.kr/static/docs/article_main.html#resources-board-article-register
   register(params,boardId) {
     return httpService.post(`/board/${boardId}/article`, params);
   },
 
   
   updatePost(id, params,boardId) {
     return httpService.put(`/board/${boardId}/article/${id}`, params);
     //return httpService.put(`/board/SNS1/article/${id}`, params);
   },
 
   
  
 };
 
 // export const
 export default checklistApi;